import { Component, computed, DestroyRef, effect, inject, OnInit } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';

import { startWith, distinctUntilChanged } from 'rxjs';

import { EditorTranslationsService } from '../../../services/editor-translations.service';

@Component({
  selector: 'empathy-translations-language-toggle',
  templateUrl: 'translations-language-toggle.component.html'
})
export class TranslationsLanguageToggleComponent implements OnInit {
  translatationsService = inject(EditorTranslationsService);

  languageControl = new FormControl<string | null>(null);

  languageList$ = computed(() => {
    const activeTranslationLanguage = this.translatationsService.activeTranslationLanguage$();
    const defaultTranslationLanguage = this.translatationsService.defaultTranslationLanguage$();

    if (!activeTranslationLanguage || !defaultTranslationLanguage) {
      return [];
    }

    return [
      { text: defaultTranslationLanguage.name, value: defaultTranslationLanguage.code },
      { text: activeTranslationLanguage.name, value: activeTranslationLanguage.code }
    ];
  });

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    effect(
      () => {
        const languageCode = this.translatationsService.previewUseDefaultLanguage$()
          ? this.translatationsService.defaultLanguageCode$()
          : this.translatationsService.activeTranslationLanguage$()?.code;

        this.languageControl.setValue(languageCode, { emitEvent: false });
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    this.languageControl.valueChanges
      .pipe(startWith(this.languageControl.value), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe((code) => {
        if (code) {
          this.translatationsService.previewUseDefaultLanguage$.set(code === this.translatationsService.defaultLanguageCode$());
        }
      });
  }
}
